import { Icon } from './Alerts.styles';

const alertIcon = `${process.env.CVNA_APP_CDN_ASSETS_PATH}/images/alert_icon.png`;

const AlertIcon = () => <Icon src={alertIcon} />;

export default AlertIcon;
